import { ErrorpageWrap } from './style/CommonStyledComponents';
import img_unsupported_url from 'images/common/unsupported_url.svg';
import { i18ntrans } from 'language/i18nkey';

const NotFoundPage = () => {
  const getTranslation = (key: string): string => {
    return i18ntrans.header(key as any);
  };

  return (
    <ErrorpageWrap>
      <div className={'Errorpage'}>
        <div className={'container'}>
          <div className={'error-content'}>
            <img src={img_unsupported_url} alt="Not Found" />
            <p className={'error-tit'}>{getTranslation('I18N_UNSUPPORTED_URL_TIT')}</p>
            <p className={'error-txt'}>{getTranslation('I18N_UNSUPPORTED_URL_TXT')}</p>
          </div>
        </div>
      </div>
    </ErrorpageWrap>
  );
};

export default NotFoundPage;